module.exports = __webpack_public_path__ + "static/example_3-5bd8dc8c9f0191f4c9b8fb9ca25777a8.jpg";